import React, { FC, useMemo } from "react";
import {
    MultipleSelect,
    MultiSelectItem,
} from "Shared/components/multiple-select";
import { PickOff } from "Shared/util/types";
import { usePayoutInformationContext } from "../../context";
import { DataTableItem } from "../types";

type DataTableMultipleSelectProps = {
    item: DataTableItem;
    onSelectedCurrenciesChange: (
        supportedCurrencies: DataTableItem["supportedCurrencies"],
        item: PickOff<DataTableItem, "supportedCurrencies">,
    ) => void;
};

export const DataTableMultipleSelect: FC<DataTableMultipleSelectProps> = ({
    item,
    onSelectedCurrenciesChange,
}) => {
    const { currency: primaryCurrency, supportedCurrencies } = item;

    const {
        values: { currencies },
    } = usePayoutInformationContext();

    const handleCurrenciesChanged = (key: MultiSelectItem["key"]) => {
        const exists = supportedCurrencies?.some((x) => x === key);

        const newList = exists
            ? supportedCurrencies?.filter((x) => x !== key)
            : [...(supportedCurrencies ?? []), key];

        onSelectedCurrenciesChange(newList, item);
    };

    const items: MultiSelectItem[] = useMemo(
        () =>
            currencies.map((currency) => ({
                disabled: primaryCurrency === currency,
                key: currency,
                label: currency,
            })),
        [currencies, primaryCurrency],
    );

    return (
        <MultipleSelect
            items={items}
            label={supportedCurrencies?.join(", ") || ""}
            onChange={handleCurrenciesChanged}
            selectedItems={supportedCurrencies ?? []}
        />
    );
};
